import { useEffect, useState } from "react";

import { bannerAnalyticsService } from "../services/bannerAnalyticsService";

export default function useBannerAnalytics() {

    const [dashboard, setDashboard] = useState(null);

    const [performance, setPerformance] = useState([]);

    const [timeline, setTimeline] = useState([]);

    const [loading, setLoading] = useState(true);

    const [error, setError] = useState(null);

    useEffect(() => {

        loadAnalytics();

    }, []);

    const loadAnalytics = async () => {

        try {

            setLoading(true);

            setError(null);

            const [
                dashboardData,
                performanceData,
                timelineData,
            ] = await Promise.all([

                bannerAnalyticsService.getDashboard(),

                bannerAnalyticsService.getPerformance(),

                bannerAnalyticsService.getTimeline(),

            ]);

            setDashboard(dashboardData);

            setPerformance(performanceData);

            setTimeline(timelineData);

        } catch (err) {

            console.error(err);

            setError(err);

        } finally {

            setLoading(false);

        }

    };

    return {

        dashboard,

        performance,

        timeline,

        loading,

        error,

        reload: loadAnalytics,

    };

}